import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { extractErrorsFromApi } from '../../../common/helpers';
import { type Merchant } from '../../../common/types';
import RenderErrorBag from '../../../components/render-error-bag';
import { toast } from 'react-toastify';
import { useApproveMerchantMutation } from '../merchant.api-slice';
import { useTranslation } from 'react-i18next';

interface IProps {
  isOpen: boolean;
  toggleApproveModal: () => any;
  item: Merchant | null;
}

const ApproveMerchant: React.FC<IProps> = ({ item, isOpen, toggleApproveModal }) => {
  const [approveItem, { isLoading, isSuccess, isError, error, reset }] = useApproveMerchantMutation();
  const [errorBag] = useState<string[]>([]);
  const { t } = useTranslation();

  const handleApproveItem = (): void => {
    if (item?.id == null) {
      return;
    }
    void approveItem(item.id);
    toggleApproveModal();
  };

  useEffect(() => {
    if (isSuccess) {
      toast(t('devices.approve.successMessage'));
      reset();
    }
    if (isError && error != null) {
      toast.error(extractErrorsFromApi(error).toString());
      reset();
    }
  }, [isSuccess, error]);

  return (
    <>
      {isOpen && item != null ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="my-6 mx-auto w-1/2">
              <div className="border-0 rounded-lg shadow-lg flex flex-col bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold">{t('devices.approve.title')}</h3>
                  <button
                    className="p-1 ml-auto border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={toggleApproveModal}
                  >
                    <AiOutlineClose size={20} />
                  </button>
                </div>
                <div className="relative p-6 flex-auto w-full">
                  {errorBag.length > 0 && <RenderErrorBag errorBag={errorBag} />}
                  {t('devices.approve.body')}
                </div>
                <div className="w-full flex justify-end px-4 space-x-2 py-6 mt-4 border-t border-solid border-slate-200 rounded-b">
                  <button className="text-black px-5 py-2 rounded-lg bg-gray-200" onClick={toggleApproveModal}>
                    {t('devices.approve.cancelBtnLabel')}
                  </button>
                  <button
                    disabled={isLoading}
                    onClick={handleApproveItem}
                    className="text-white px-4 py-2 rounded-lg bg-[#1D8A43]"
                  >
                    {t('devices.approve.saveBtnLabel')}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default ApproveMerchant;
